import { APIcallerv2 } from '../APIcaller';

const BASE = `/backoffice/api-keys`;

const createPublicApiKey = (userName, resources, restrictedStoreIds) =>
  APIcallerv2.apiPost(BASE, { userName, resources, restrictedStoreIds });

const getApiKeysByClientId = () => APIcallerv2.apiGet(BASE);

const getApiKeysResourcesById = (id) => APIcallerv2.apiGet(`${BASE}/${id}/resources`);

const updateApiKey = (id, resources, restrictedStoreIds) =>
  APIcallerv2.apiPatch(`${BASE}/${id}`, { resources, restrictedStoreIds });

const deleteApiKey = (id) => APIcallerv2.apiDelete(`${BASE}/${id}`);

export const publicKeysService = {
  createPublicApiKey,
  getApiKeysByClientId,
  getApiKeysResourcesById,
  updateApiKey,
  deleteApiKey,
};
